import { get, apiPrefix } from './common';
const getNexusNetSuiteImport = () => get(`${apiPrefix}/jobs/nexus-netsuite-import`);
const getNexusNetSuiteExport = (expRptIds) => {
    if (expRptIds && expRptIds.length) {
        const joinedExpRptIds = expRptIds.map((id) => `expRptIds=${id}`).join('&');
        return get(`${apiPrefix}/jobs/nexus-netsuite-export/?${joinedExpRptIds}`);
    }
    return get(`${apiPrefix}/jobs/nexus-netsuite-export`);
};
const getNexusNetSuiteSync = (param = false) => get(`${apiPrefix}/jobs/nexus-netsuite-sync?syncOnly=${param}`);
const getNexusNetSuiteActionPending = () => get(`${apiPrefix}/jobs/nexus-netsuite-action-pending?jobRunDto.pendingOnly=true`);
const getNetSuiteObjectMap = (id, companyId, certifyId, certifyTable, netSuiteObjectId, netSuiteIsActive) => {
    let query = '';
    if (id)
        query += `query.id=${id}&`;
    if (companyId)
        query += `query.companyId=${companyId}&`;
    if (certifyId)
        query += `query.certifyId=${certifyId}&`;
    if (certifyTable)
        query += `query.certifyTable=${certifyTable}&`;
    if (netSuiteObjectId)
        query += `query.netSuiteObjectId=${netSuiteObjectId}&`;
    if (netSuiteIsActive)
        query += `query.netSuiteIsActive=${netSuiteIsActive}`;
    return get(`${apiPrefix}/netsuite-object-map?${query}`);
};
export { getNexusNetSuiteImport, getNexusNetSuiteExport, getNexusNetSuiteSync, getNexusNetSuiteActionPending, getNetSuiteObjectMap };
